export function validateRequired(value: string) {
  if (!value) {
    return "This value is required."
  }
}